import React from 'react'

import { ReloadOutlined } from '@ant-design/icons'
import ListPageHeader from '@shared/ListPageHeader'
import NotificationList from '@shared/notifications/NotificationList'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'

import { notificationService } from '@services/admin/notificationService'

export default function AdminNotificationsList() {
  const { t } = useTranslation()
  const [refreshKey, setRefreshKey] = React.useState(0)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['notifications']}
        actions={
          <Button
            icon={<ReloadOutlined />}
            onClick={() => setRefreshKey(prev => prev + 1)}
          >
            {t('common.refresh')}
          </Button>
        }
      />
      <NotificationList
        key={refreshKey}
        service={notificationService}
        role="admin"
      />
    </div>
  )
}
